var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-wrapper"},[_vm._t("header"),_c('div',{staticClass:"modal-container-wrapper"},[_c('div',{staticClass:"container py-sm-5"},[_c('div',{staticClass:"modal-container"},[_vm._t("default")],2)])])],2)}
var staticRenderFns = []

export { render, staticRenderFns }